import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export default new Router({
    linkActiveClass: 'active',
    Router,
    routes: [
        {
            path: '/',
            redirect: {
                name: '首页',
                path: '/main',
                // component: (resolve) => {
                //     require(['@/components/main.vue'], resolve)
                // }
            }
        },

        // 登录
        {
            path: '/login',
            name: '登录',
            component: () => import('@/components/login.vue')
        },

        // 菜单栏
        {
            path: '/menu',
            component: () => import('@/components/comps/menu.vue'),
            children: [
                // {
                //     path: '/',
                //     component: () => import('@/components/main.vue')
                // },
                // {
                //     path: '/main',
                //     name: '工作台',
                //     component: () => import('@/components/main.vue')
                // },
                {
                    path: '/main',
                    name: '首页',
                    component: () => import('@/components/home.vue')
                },


                // 数据统计
                {
                    path: '/orderAnalysis',
                    name: '订单分析',
                    component: () => import('@/components/data_analysis/order_analysis.vue')
                },{
                    path: '/balanceAnalysis',
                    name: '收支分析',
                    component: () => import('@/components/data_analysis/balance_analysis.vue')
                },{
                    path: '/userAnalysis',
                    name: '用户分析',
                    component: () => import('@/components/data_analysis/user_analysis.vue')
                },


                // 运营管理
                {
                    path: '/dispatchCenter',
                    name: '调度中心',
                    component: () => import('@/components/managcent/dispatch.vue')
                },
                // {
                //     path: '/dataScreen',
                //     name: '数据大屏',
                //     component: () => import('@/components/managcent/dataScreen.vue')
                // },

                // 资产管理
                {
                    path: '/carsMana',
                    name: '车辆管理',
                    component: () => import('@/components/mmassets/carsManage.vue')
                },{
                    path: '/carDetails',
                    name: '车辆详情',
                    component: () => import('@/components/mmassets/cardetails.vue')
                },{
                    path: '/controlMana',
                    name: '中控管理',
                    component: () => import('@/components/mmassets/control.vue')
                },{
                    path: '/helmetMana',
                    name: '头盔管理',
                    component: () => import('@/components/mmassets/helmet.vue')
                },

                // 人员管理
                {
                    path: '/userList',
                    name: '用户管理',
                    component: () => import('@/components/personlmana/userslist.vue')
                },{
                    path: '/userdetail',
                    name: '用户详情',
                    component: () => import('@/components/personlmana/userdetail.vue')
                },{
                    path: '/proxylist',
                    name: '代理管理',
                    component: () => import('@/components/personlmana/proxylist.vue')
                },

                // 订单管理
                {
                    path: '/rideorder',
                    name: '骑行订单',
                    component: () => import('@/components/ordermanag/rideorder.vue')
                },{
                    path: '/orderdetail',
                    name: '订单详情',
                    component: () => import('@/components/ordermanag/orderdetails.vue')
                },
                // {
                //     path: '/rechargeorder',
                //     name: '充值订单',
                //     component: () => import('@/components/ordermanag/rechargeorder.vue')
                // },{
                //     path: '/nodeposit',
                //     name: '免押金卡订单',
                //     component: () => import('@/components/ordermanag/noDeposit.vue')
                // },
                {
                    path: '/rechargeorder',
                    name: '充值余额订单',
                    component: () => import('@/components/market/rechargebalanceorder.vue')
                },{
                    path: '/nodeposit',
                    name: '会员服务卡订单',
                    component: () => import('@/components/market/servicecardorder.vue')
                },{
                    path: '/ridecard',
                    name: '骑行卡订单',
                    component: () => import('@/components/ordermanag/cardorderlist.vue')
                },{
                    path: '/refundlist',
                    name: '余额退款订单',
                    component: () => import('@/components/ordermanag/refundlist.vue')
                },

                // 营销管理
                {
                    path: '/ridecoupon',
                    name: '骑行券',
                    component: () => import('@/components/market/ridecoupon.vue')
                },

                // 运维管理
                {
                    path: '/dispatch',
                    name: '调度记录',
                    component: () => import('@/components/operat/dispatch.vue')
                },{
                    path: '/dispatchDetail',
                    name: '调度详情',
                    component: () => import('@/components/operat/dispatchDetail.vue')
                },{
                    path: '/replacebatte',
                    name: '换电记录',
                    component: () => import('@/components/operat/replacebatte.vue')
                }, {
                    path: '/batteDetail',
                    name: '换电详情',
                    component: () => import('@/components/operat/batteDetail.vue')
                },{
                    path: '/repairlist',
                    name: '维修记录',
                    component: () => import('@/components/operat/repairlist.vue')
                },{
                    path: '/repairDetail',
                    name: '维修详情',
                    component: () => import('@/components/operat/repairDetail.vue')
                },{
                    path: '/violat',
                    name: '违规记录',
                    component: () => import('@/components/operat/violat.vue')
                },{
                    path: '/violatDetail',
                    name: '违规详情',
                    component: () => import('@/components/operat/violatDetail.vue')
                },

                // 财务管理
                // {
                //     path: '/refund',
                //     name: '退押金申请',
                //     component: refund
                // },
                {
                    path: '/withdraw',
                    name: '提现申请',
                    component: () => import('@/components/inance/withdraw.vue')
                },
                // {
                //     path: '/financialStat',
                //     name: '财务统计',
                //     component: () => import('@/components/inance/financialstat.vue')
                // },

                // 设置
                {
                    path: '/costConfig',
                    name: '费用设置',
                    component: () => import('@/components/setup/costconfig.vue')
                }, 
                // {
                //     path: '/maintain',
                //     name: '运维设置',
                //     component: () => import('@/components/setup/maintain.vue')
                // }, 
                {
                    path: '/userconf',
                    name: '用户配置',
                    component: () => import('@/components/setup/userconf.vue')
                }, {
                    path: '/activity',
                    name: '活动配置',
                    component: () => import('@/components/setup/activity.vue')
                }, {
                    path: '/system',
                    name: '后台配置',
                    component: () => import('@/components/setup/system.vue')
                }, {
                    path: '/documents',
                    name: '文档配置',
                    component: () => import('@/components/setup/document.vue')
                }, {
                    path: '/authority',
                    name: '权限设置',
                    component: () => import('@/components/setup/authority.vue')
                }, {
                    path: '/account',
                    name: '平台账号',
                    component: () => import('@/components/setup/account.vue')
                },{
                    path: '/batterySolut',
                    name: '电池方案',
                    component: () => import('@/components/setup/battery_solut.vue')
                },

                // 消息管理
                // {
                //     path: '/msglist',
                //     name: '消息列表',
                //     component: () => import('@/components/msgmanag/msglist.vue')
                // },


                // 404
                {
                    path: '/*',
                    name: '404',
                    component: (resolve) => {
                        require(['@/components/404.vue'], resolve)
                    }
                }
            ]
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js